// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import React, { useState } from "react";
import FindTransactionScreen from "..";
import { TModal } from "../../../../../types/common.type";
import TransactionsScreen from "../../../../../context/Transactions.context";
import { useQuery } from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import {
  IFindDebts,
  IFindTransactions,
  IPayDebt,
} from "../../../../../types/common.interface";
import Context from "../../../../../context";
import FindDebtScreen from "..";
import utils from "../../../../../utils";

// import {useQuery} from "react-query";
// import {DebtContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const DebtsContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedDebt, setSelectedDebt] = useState<any>();

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  const [requestDebt, setRequestDebt] = React.useState<IFindDebts>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    filters: {},
  });

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const getAllDebt = useQuery(
    [values.useQueryKeys.getAllDebts, requestDebt, selectedYear?._id],
    () =>
      api.post.common.findDebts({
        ...requestDebt,
        academicYear: selectedYear?._id,
      })
  );

  async function onPayDebt(formData: IPayDebt) {
    console.log(formData);
    setIsLoading(true);
    const result = await api.put.administrator.payDebtByAdmin(formData);
    if (result) {
      utils.successHandler(Number(result?.CODE));
      getAllDebt.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <Context.DebtsScreen.Provider
      value={{
        isLoading,
        showModal,
        setIsLoading,
        setShowModal,
        requestDebt,
        setRequestDebt,
        selectedDebt,
        setSelectedDebt,
        onPayDebt,
      }}
    >
      <FindDebtScreen rqData={getAllDebt} showModalData={{}} />
    </Context.DebtsScreen.Provider>
  );
};

export default DebtsContainer;
